import { Helmet } from 'react-helmet-async';
import MessageView from 'src/sections/message/view/message-view';

export default function MessagePage() {

  return (
    <>
      <Helmet>
        <title> Hireintel - Message </title>
      </Helmet>

      <MessageView />
    </>
  );
}
